import React, { useMemo } from 'react';
import { USER_LIST_QUERY } from '../io';
import GroupIcon from '@mui/icons-material/Group';
import { Card } from '@totalsoft/rocket-ui';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import UserListItem from './UserListItem';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import userStore from '../userStore';

const columns = [
  { name: 'name', caption: 'Users.Name' },
  { name: 'remark', caption: 'Users.Remark' },
  { name: 'inactive', caption: 'Users.Inactive' },
  { name: 'lastLoginDate', caption: 'Users.LastLoginDate' },
  { name: 'actions', caption: 'Actions', width: 15 }
];

const UsersListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: USER_LIST_QUERY,
        name: 'userPagedList'
      }
    }),
    []
  );

  return (
    <Card icon={GroupIcon}>
      <TableListBrowser name='user-browser' store={userStore} ItemComponent={UserListItem} columns={columns} />
      <ExportModalComponent store={userStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={userStore} options={fetchingOptions} />
    </Card>
  );
};

export default UsersListBrowser;
